export class SmsMfaVerification {
    
    public code: string = null;
    public session: string = null;
    public username: string = null;

}